import { useInviteEligibilityQuery } from '@src/queries/InviteEligibilityQuery.generated'
import { InviteCoWorkerRoute } from '@src/routes'
import { useCurrentUser } from '@utils/useCurrentUser'
import { useUserSession } from '@utils/useUserSession'
import { getLocalizedUrl } from '@src/utils/regional'
import getConfig from 'next/config'
import { UserErpType } from '@src/types/graphql-types'
import countriesMap from '@localization/countries.json'
import { useCheckUserCountry } from './useCheckUserCountry'

interface ShowCoworkerConfig {
  shouldShowInviteCoworker: boolean
  inviteCoworkerUrl: string
}

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

export const useShowInviteCoworker = (): ShowCoworkerConfig => {
  const {
    currentUser,
    singlePartners,
    inviteCoWorkerAffiliation,
    userErpType,
  } = useCurrentUser()
  const isChinaUser = useCheckUserCountry(countriesMap.CN.countryCode)
  const isBlueUser = userErpType === UserErpType.Blue
  const partnerInfo =
    currentUser?.__typename === 'LoggedInUser' && currentUser?.soldToPartners
      ? [...currentUser?.soldToPartners]
      : []

  const defaultPartner = partnerInfo.find(
    (partnerItem) => partnerItem.isDefault
  )
  const userCountryCode =
    currentUser?.__typename === 'LoggedInUser'
      ? currentUser?.metadata?.country
      : ''

  const { data: showInviteCoWorker } = useInviteEligibilityQuery({
    variables: {
      input: {
        salesOrg: defaultPartner?.salesOrg,
        soldTo: defaultPartner?.soldTo,
        email: currentUser?.email,
        soldToCountry: userCountryCode,
      },
    },
    skip:
      !defaultPartner ||
      !featureFlags.inviteCoworker ||
      !currentUser?.email ||
      !userCountryCode ||
      !singlePartners ||
      (!isChinaUser && isBlueUser),
  })

  const { userSession } = useUserSession()
  const inviteCoworkerUrl = getLocalizedUrl(
    userSession,
    InviteCoWorkerRoute.index()
  )

  return {
    shouldShowInviteCoworker:
      featureFlags.inviteCoworker &&
      singlePartners &&
      inviteCoWorkerAffiliation &&
      showInviteCoWorker?.getInviteEligibility &&
      (isBlueUser ? isChinaUser : true),
    inviteCoworkerUrl: inviteCoworkerUrl.as,
  }
}
